/* eslint-disable */
export default {
  logged: '기록됨',
  unlogged: '작업 안 함',
  faxNotSupported: '팩스 기록은 지원되지 않습니다.',
} as const;

// @key: @#@"logged"@#@ @source: @#@"Logged"@#@
// @key: @#@"unlogged"@#@ @source: @#@"Unworked"@#@
// @key: @#@"faxNotSupported"@#@ @source: @#@"To log fax is not supported."@#@
